/* "Comentários e notas" no prato: quem postou decide. Palpites de preço
   e caloria e reações continuam de qualquer jeito. Desligar esconde os
   comentários (não apaga) e tira o prato das missões de nota. */
export function ChaveDeConversa({ ligado, aoMudar }: { ligado: boolean; aoMudar: (v: boolean) => void }) {
  return (
    <div className="card">
      <div className="switch-row">
        <div className="switch-corpo">
          <div className="switch-titulo">💬 Comentários e notas</div>
          <div className="switch-sub">
            {ligado
              ? "O grupo pode comentar e dar nota. Palpites e reações valem sempre."
              : "Desligado: sem comentários nem notas neste prato, e ele não conta nas missões de nota. Palpites e reações continuam."}
          </div>
        </div>
        <button className={`switch ${ligado ? "on" : ""}`} onClick={() => aoMudar(!ligado)}
          role="switch" aria-checked={ligado} aria-label="Comentários e notas">
          <span />
        </button>
      </div>
    </div>
  );
}
